module.exports = __webpack_public_path__ + "static/screenie_search_2-16b886329a46a6d09aa2da3d524c533b.jpg";